var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "eu-flex eu-column eu-row_sm" }, [
    !_vm.isCreditCard
      ? _c(
          "div",
          { staticClass: "eu-flex-item" },
          [
            !_vm.isPix
              ? _c(
                  "a",
                  {
                    staticClass: "emd-link",
                    attrs: {
                      href:
                        "https://wa.me/?text=Link para pagamento: " +
                        _vm.createdOrderResponse.payment_url,
                      target: "_blank",
                      "data-action": "share/whatsapp/share",
                    },
                  },
                  [
                    _c("i", { staticClass: "uil uil-whatsapp" }),
                    _vm._v(" " + _vm._s(_vm.$t("share.whatsapp")) + " "),
                  ]
                )
              : _vm._e(),
            _vm.isPix ? _c("pix-clipboard-copy") : _vm._e(),
          ],
          1
        )
      : _vm._e(),
    _vm.showEmailSend
      ? _c("div", { staticClass: "eu-flex-item" }, [
          _c(
            "a",
            {
              staticClass: "emd-link",
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.createEmailNotification },
            },
            [
              _vm.loadingEmail
                ? _c("i", {
                    staticClass: "emd-text _color_subtle uil uil-spinner-alt",
                  })
                : _vm._e(),
              _vm.emailSent && !_vm.loadingEmail
                ? _c("i", { staticClass: "uil uil-check-circle" })
                : _vm._e(),
              !_vm.emailSent && !_vm.loadingEmail
                ? _c("i", { staticClass: "uil uil-envelope" })
                : _vm._e(),
              _vm._v(" " + _vm._s(_vm.$t("share.email")) + " "),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }